module.exports = __webpack_public_path__ + "assets/img/00045.df20daa7.png";